import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 서비스 설정과 국가 목록 — 부팅할 때 한 번 받아 둔다 */
export type ServiceSettingState = {
    setting: Record<string, unknown>
    countries: unknown[]
}

const state: ServiceSettingState = {
    setting: {},
    countries: [],
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    AC_ServiceSetting: (store: Store, param: Record<string, unknown>): void => {
        store.commit('MU_ServiceSetting', param)
    },
    AC_CountryList: (store: Store, param: unknown[]): void => {
        store.commit('MU_CountryList', param)
    },
}

const mutations = {
    MU_ServiceSetting: (state: ServiceSettingState, param: Record<string, unknown>): void => {
        state.setting = param
    },
    MU_CountryList: (state: ServiceSettingState, param: unknown[]): void => {
        state.countries = param
    },
}

const servicesetting: Module<ServiceSettingState, StoreState> = { state, actions, mutations }

export default servicesetting
